var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"no-data"},[_c('div',[_vm._v("未找到符合條件的數據")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }